import React, { useEffect, useState } from "react";
import { mainApi } from "../providers/api";
import Loading from "../components/Loading";
import SignItem from "./components/Sign";
const Home = () => {
  const [data, setdata] = useState();
  const [loading, setloading] = useState(false);
  const [offset, setoffset] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      try {
        setloading(true);

        const result = await mainApi({
          url: `/service/sign`,
          method: `POST`,
          auth: {
            username: "hsct",
            password:
              "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
          },
          data: {
            offset: offset,
            limit: 20,
            sort: {
              sequence: -1,
            },
          },
        });
        console.log("🚀 ~ fetch ~ result:", result.data);

        setdata(result.data.items);
        setloading(false);
      } catch (err) {
        setloading(false);
        console.log("err", err);
      }
    };

    fetch();
  }, []);
  return (
    <div className="flex p-4 pb-28">
      <div className="flex flex-wrap w-full justify-center md:justify-start">
        {loading ? (
          <Loading width="w-16" />
        ) : (
          data?.map((row, index) => {
            return <SignItem key={index} data={row} />;
          })
        )}
      </div>
    </div>
  );
};

export default Home;
